import styled from 'styled-components';
import { CarOptionStyled } from '../CarOptionStyled';
import { rem } from 'polished';

export const CarOptionStyledAP = styled(CarOptionStyled)``;
